export default __webpack_public_path__ + "static/media/student.4cb593d1.svg";